import React, {useState, useEffect} from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Select from 'react-select';

var product_id = "";

function NewStock (){

  const [Products, SetProducts] = useState([])

  useEffect(() => {
    const fetchProducts = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/products.json');
      const jsonresult = await result.json()
      SetProducts(jsonresult)
    }
    fetchProducts();
  }, [])

  const [MinAvailableRollWidths, SetMinAvailableRollWidths] = useState([])
  const [MaxAvailableRollWidths, SetMaxAvailableRollWidths] = useState([])
  const [AvailableConsumableTypes, SetAvailableConsumableTypes] = useState([])
  const [AvailableConsumableQuantity, SetAvailableConsumableQuantity] = useState([])

  const [mode, setMode] = useState("roll"); // "roll", "consumable", or "pack"
  var stock_type = "";

  var Length = 0;
  const setLength = () => {
    var length_select = document.getElementById('Length');
    Length = length_select.value;
  }
  var Width = 0;
  const setWidth = () => {
    var length_select = document.getElementById('Width');
    Width = length_select.value;
  }

  var business_unit = "unallocated";
  const setBusiness_Unit = () => {
    var business_unit_select = document.getElementById('BusinessUnit_Select');
    business_unit = business_unit_select.options[business_unit_select.selectedIndex].value;
  }

  var Quantity = 0;
  const setQuantity = () => {
    var Quantity_select = document.getElementById('Quantity');
    Quantity = Quantity_select.value;
  }

  var Consumable_Quantity = 0;
  const setConsumable_Quantity = () => {
    var Consumable_Quantity_select = document.getElementById('Consumable_Quantity');
    Consumable_Quantity = Consumable_Quantity_select.value;
  }

  var Consumable_Type = "";
  const setConsumable_Type = () => {
    var Consumable_Type_select = document.getElementById('Consumable_Type');
    Consumable_Type = Consumable_Type_select.options[Consumable_Type_select.selectedIndex].value;
  }

  var Building = "Warehouse";
  const setBuilding = () => {
    var Building_select = document.getElementById('Building_Select');
    Building = Building_select.value;
  }

  var Position = "";
  const setPosition = () => {
    var Position_select = document.getElementById('Positional_Location_Select');
    Position = Position_select.value;
  }

  var Condition = "GOOD";
  const setCondition = () => {
    var Condition_select = document.getElementById('Stock_Condition_Select');
    Condition = Condition_select.value;
  }

  var Reference = "";
  const setReference = () => {
    var Reference_select = document.getElementById('Stock_Reference_Select');
    Reference = Reference_select.value;
  }

  var ProductCode = "";
  const setProductCode = () => {
    var ProductCode_select = document.getElementById('Product_Code');
    ProductCode = ProductCode_select.value;
  }

  var Style = "";
  const setStyle = () => {
    var Style_select = document.getElementById('Style');
    Style = Style_select.value;
  }

  var PackContents = "";
  const setPackContents = () => {
    var PackContents_select = document.getElementById('Pack_Contents');
    PackContents = PackContents_select.value;
  }

  var PackSize = 0;
  const setPackSize = () => {
    var PackSize_select = document.getElementById('Pack_Size');
    PackSize = PackSize_select.value;
  }

  const SelectProductType = (event) => {
    product_id = event.value;
    var product = Products.find(product => product.id == product_id);

    if (product.product_type == "Carpet") {
      stock_type = "StockFlooringRoll"
      SetMinAvailableRollWidths(4)
      SetMaxAvailableRollWidths(5)
    }
    else if (product.product_type == "Pack") {
      stock_type = "StockFlooringPack"
      setMode("pack");
    }
    else if (product.product_type == "Vinyl") {
      stock_type = "StockFlooringRoll"
      SetMinAvailableRollWidths(2)
      SetMaxAvailableRollWidths(4)
    }
    else if (product.product_type == "Matting") {
      stock_type = "StockFlooringRoll"
      SetMinAvailableRollWidths(1)
      SetMaxAvailableRollWidths(2)
    }
    else if (product.product_type == "Blades") {
      stock_type = "StockConsumable"
      let types = ["Box"]
      let quantity = ["100"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Underlay") {
      stock_type = "StockConsumable"
      let types = ["Roll"]
      let quantity = ["1"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Metals") {
      stock_type = "StockConsumable"
      let types = ["Length"]
      let quantity = ["1"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Gripper") {
      stock_type = "StockConsumable"
      let types = ["Box"]
      let quantity = ["100"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Glues") {
      stock_type = "StockConsumable"
      let types = ["Box","Tub","Can"]
      let quantity = ["1", "12"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Rug") {
      stock_type = "StockConsumable"
      let types = ["Roll"]
      let quantity = ["1"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Sealant") {
      stock_type = "StockConsumable"
      let types = ["Tube"]
      let quantity = ["1","12"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Screed") {
      stock_type = "StockConsumable"
      let types = ["Bag"]
      let quantity = ["1"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Coving") {
      stock_type = "StockConsumable"
      let types = ["Length"]
      let quantity = ["1"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Tape") {
      stock_type = "StockConsumable"
      let types = ["Roll"]
      let quantity = ["1"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Cleaner") {
      stock_type = "StockConsumable"
      let types = ["Tub","Bottle"]
      let quantity = ["1"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Fasteners") {
      stock_type = "StockConsumable"
      let types = ["Box","Tub"]
      let quantity = ["1"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Thread") {
      stock_type = "StockConsumable"
      let types = ["Spindle"]
      let quantity = ["1"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Binding") {
      stock_type = "StockConsumable"
      let types = ["Spindle"]
      let quantity = ["1"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Whipping") {
      stock_type = "StockConsumable"
      let types = ["Spindle"]
      let quantity = ["1"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else if (product.product_type == "Timber") {
      stock_type = "StockConsumable"
      let types = ["Length","Sheet"]
      let quantity = ["1"]
      SetAvailableConsumableTypes(types)
      SetAvailableConsumableQuantity(quantity)
      Consumable_Type = types[0]
      Consumable_Quantity = quantity[0]
    }
    else {
      stock_type = "StockConsumable"
    }

    if (stock_type == "StockConsumable") {
      setMode("consumable");
    } else if (stock_type == "StockFlooringRoll"){
      setMode("roll");
    }
  }

  var RollID = 0;
  const setRollID = () => {
    var RollID_select = document.getElementById('Roll_ID');
    RollID = RollID_select.value;
  }

  var myData = "";
  const submitStock = async () => {
    // Read common fields from DOM
    const businessUnitSelect = document.getElementById('BusinessUnit_Select');
    const buildingSelect = document.getElementById('Building_Select');
    const positionInput = document.getElementById('Positional_Location_Select');
    const conditionInput = document.getElementById('Stock_Condition_Select');
    const referenceInput = document.getElementById('Stock_Reference_Select');

    if (mode == "consumable") {
      // Always read from DOM to capture default values
      const quantityInput = document.getElementById('Quantity');
      const consumableTypeSelect = document.getElementById('Consumable_Type');
      const consumableQuantitySelect = document.getElementById('Consumable_Quantity');

      myData = {
        stock: {
          stock_type_type: "StockConsumable",
          product_id: product_id,
          in_stock: quantityInput.value,
          business_unit: businessUnitSelect.value,
          building: buildingSelect.value,
          position: positionInput.value,
          condition: conditionInput.value,
          reference: referenceInput.value
        },
        stock_type: {
          consumable_quantity: consumableQuantitySelect.value,
          consumable_type: consumableTypeSelect.value
        }
      }
    } else if (mode == "roll") {
      // Always read from DOM to ensure values are captured
      const lengthInput = document.getElementById('Length');
      const widthInput = document.getElementById('Width');
      const rollIdInput = document.getElementById('Roll_ID');

      myData = {
        stock: {
          stock_type_type: "StockFlooringRoll",
          product_id: product_id,
          in_stock: 1,
          business_unit: businessUnitSelect.value,
          building: buildingSelect.value,
          position: positionInput.value,
          condition: conditionInput.value,
          reference: referenceInput.value
        },
        stock_type: {
          width: widthInput.value,
          length: lengthInput.value,
          roll_id: rollIdInput.value
        }
      }
    } else if (mode == "pack") {
      // Always read from DOM to ensure values are captured
      const quantityInput = document.getElementById('Quantity');
      const productCodeInput = document.getElementById('Product_Code');
      const styleInput = document.getElementById('Style');
      const packContentsInput = document.getElementById('Pack_Contents');
      const packSizeInput = document.getElementById('Pack_Size');

      myData = {
        stock: {
          stock_type_type: "StockFlooringPack",
          product_id: product_id,
          in_stock: quantityInput.value,
          business_unit: businessUnitSelect.value,
          building: buildingSelect.value,
          position: positionInput.value,
          condition: conditionInput.value,
          reference: referenceInput.value
        },
        stock_type: {
          product_code: productCodeInput.value,
          style: styleInput.value,
          pack_contents: packContentsInput.value,
          pack_size: packSizeInput.value
        }
      }
    }

    const response = await fetch(import.meta.env.VITE_URL + '/stocks', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(myData)
    })

    const resultInJson = response.status;
    console.log(resultInJson);

  }

  return (
    <div>
    <Form>
      <h1>New Stock Form</h1>
      <Form.Text>
        Select the Product
          <Select
            options={Products.map(opt => ({ label: opt.name, value: opt.id}))}
            onChange={event => SelectProductType(event)}
            className="mb-3 col-6"
            aria-label="Product"
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 9999,
                backgroundColor: 'white'
              }),
              menuList: (provided) => ({
                ...provided,
                backgroundColor: 'white'
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : 'white',
                color: state.isSelected ? 'white' : 'black'
              })
            }}
          />
      </Form.Text>
      {mode === "consumable" ?
      <div>
        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Text id="d" muted>
              Enter the Quantity to add into Stock.
              <FloatingLabel id="label" label="Quantity" className='mb-3'>
                <Form.Control
                  type="number"
                  min="0"
                  placeholder="Quantity"
                  id="Quantity"
                  onChange={setQuantity}
                  required
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Text id="d" muted>
              Enter the container type.
              <FloatingLabel id="label" label="Consumable Type" className='mb-3'>
                <Form.Select
                  id="Consumable_Type"
                  onChange={setConsumable_Type}
                  defaultValue={AvailableConsumableTypes[0]}
                  key={AvailableConsumableTypes.join(',')}
                  required
                >
                  {AvailableConsumableTypes.map(item =>
                    <option key={item} value={item}>{item}</option>
                  )};
                </Form.Select>
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Text id="d" muted>
              Enter the Quantity in the container.
              <FloatingLabel id="label" label="Consumable Quantity" className='mb-3'>
                <Form.Select
                  id="Consumable_Quantity"
                  onChange={setConsumable_Quantity}
                  defaultValue={AvailableConsumableQuantity[0]}
                  key={AvailableConsumableQuantity.join(',')}
                  required
                >
                  {AvailableConsumableQuantity.map(item =>
                    <option key={item} value={item}>{item}</option>
                  )};
                </Form.Select>
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
        </Row>
      </div>
      : mode === "roll" ?
      <div>
        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Text id="Length_HelpBlock" muted>
              Enter the Length of the roll.
              <FloatingLabel id="floating_Length_label" label="Roll Length (M)" className="mb-3">
                <Form.Control
                  type="number"
                  step="0.01"
                  min="0"
                  placeholder="Length"
                  aria-describedby="Length_HelpBlock"
                  id="Length"
                  onChange={setLength}
                  required
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Text id="Width_HelpBlock" muted>
              Enter the Width of the roll.
              <FloatingLabel id="floating_Width_label" label="Roll Width (M)" className="mb-3">
                <Form.Control
                  type="number"
                  min={MinAvailableRollWidths}
                  max={MaxAvailableRollWidths}
                  placeholder="Width"
                  aria-describedby="Width_HelpBlock"
                  id="Width"
                  onChange={setWidth}
                  required
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Text id="Roll_ID_HelpBlock" muted>
              Enter the Roll ID.
              <FloatingLabel id="floating_Roll_ID_label" label="Roll ID" className="mb-3">
                <Form.Control
                  type="string"
                  placeholder="Roll ID"
                  aria-describedby="Roll_ID_HelpBlock"
                  id="Roll_ID"
                  onChange={setRollID}
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
        </Row>
      </div>
      :
      <div>
        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Text id="d" muted>
              Enter the Quantity to add into Stock.
              <FloatingLabel id="label" label="Quantity" className='mb-3'>
                <Form.Control
                  type="number"
                  min="0"
                  placeholder="Quantity"
                  id="Quantity"
                  onChange={setQuantity}
                  required
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Text id="d" muted>
              Enter the Product Code.
              <FloatingLabel id="label" label="Product Code" className='mb-3'>
                <Form.Control
                  type="text"
                  placeholder="Product Code"
                  id="Product_Code"
                  onChange={setProductCode}
                  required
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
        </Row>
        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Text id="d" muted>
              Enter the Style.
              <FloatingLabel id="label" label="Style" className='mb-3'>
                <Form.Control
                  type="text"
                  placeholder="Style"
                  id="Style"
                  onChange={setStyle}
                  required
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Text id="d" muted>
              Enter the Pack Contents.
              <FloatingLabel id="label" label="Pack Contents" className='mb-3'>
                <Form.Control
                  type="text"
                  placeholder="Pack Contents"
                  id="Pack_Contents"
                  onChange={setPackContents}
                  required
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Text id="d" muted>
              Enter the Pack Size (m²).
              <FloatingLabel id="label" label="Pack Size (m²)" className='mb-3'>
                <Form.Control
                  type="number"
                  step="0.01"
                  min="0"
                  placeholder="Pack Size"
                  id="Pack_Size"
                  onChange={setPackSize}
                  required
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
        </Row>
      </div>}
      <Row className="mb-3">
        <Form.Group as={Col}>
          <Form.Text id="business_unitHelpBlock" muted>
            Select the a business unit to allocate this stock.
          </Form.Text>
          <FloatingLabel id="floating_business_unit_label" label="Business Unit" className="mb-3">
            <Form.Select
                id="BusinessUnit_Select"
                aria-describedby="business_unitHelpBlock"
                aria-label="Business_Unit"
                onChange={setBusiness_Unit}
                required
              >
              <option value="unallocated">unallocated</option>
              <option value="Internal">Internal</option>
              <option value="Retail">Retail</option>
              <option value="Trade">Trade</option>
            </Form.Select>
          </FloatingLabel>
          <Form.Text id="building_HelpBlock" muted>
            Enter the Building Location.
            <FloatingLabel id="floating_building_label" label="Building Location" className="mb-3">
              <Form.Select
                  className="mb-1"
                  id="Building_Select"
                  aria-describedby="building_HelpBlock"
                  aria-label="Building"
                  onChange={setBuilding}
                  required
                >
                <option value="Warehouse">Warehouse</option>
                <option value="Shop">Shop</option>
              </Form.Select>
            </FloatingLabel>
          </Form.Text>
          <Form.Text id="location_HelpBlock" muted>
            Enter the Positional Location.
            <FloatingLabel id="floating_Location_label" label="Positional Location" className="mb-3">
              <Form.Control
                placeholder="Positional Location"
                aria-describedby="location_HelpBlock"
                id="Positional_Location_Select"
                onChange={setPosition}
              />
            </FloatingLabel>
          </Form.Text>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Text id="condition_HelpBlock" muted>
            Enter the Condition of the stock.
            <FloatingLabel id="floating_Condition_label" label="Stock Condition" className="mb-3">
              <Form.Control
                placeholder="Stock Condition"
                aria-describedby="condition_HelpBlock"
                id="Stock_Condition_Select"
                onChange={setCondition}
                defaultValue="GOOD"
              />
            </FloatingLabel>
          </Form.Text>
          <Form.Text id="reference_HelpBlock" muted>
            Enter a Reference for the stock.
            <FloatingLabel id="floating_Reference_label" label="Stock Reference" className="mb-3">
              <Form.Control
                placeholder="Stock Reference"
                aria-describedby="reference_HelpBlock"
                id="Stock_Reference_Select"
                onChange={setReference}
              />
            </FloatingLabel>
          </Form.Text>
        </Form.Group>
      </Row>
      <Button type="submit" onClick={submitStock}>Submit form</Button>
    </Form>
    </div>
  );
}

export default NewStock;
